<template>
    <div class="logo-block">
        <a :href="homeUrl" class="d-block">
            <img class="img-logo-block" :src="logoUrlByTheme" alt="EasyContent logo">
        </a>
    </div>
</template>

<script>

import {mapState} from "vuex";
import mixinNavbar from "@/mixins/navbar/mixin";

export default {
    name: 'LeftBlock',
    components: {

    },
    computed: {
        ...mapState({
            logoUrl: state => state.navbar.logoUrl,
            darkMenu: state => state.navbar.darkMenu,
        }),
        logoUrlByTheme() {
            let parts = this.logoUrl.split('/');
            let imgName = parts[parts.length - 1];
            if (imgName === 'easycontent-logo.svg' && this.darkMenu) {
                parts[parts.length - 1] = 'easycontent-logo-light.svg';
                return parts.join('/');
            }

            return this.logoUrl;
        }
    },
    mixins: [mixinNavbar]
}
</script>
